import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import { HtmlToPlaintextPipe } from '../../../../../shared/pipes/html-to-plaintext.pipe'

/**
 * Renders a superscript footnote marker with a tooltip preview of the footnote
 * content. Emits the id of the footnote it points at so the host decides how to
 * navigate to it.
 *
 * The markup mirrors the anchors generated by the `processFootnotes` pipe so
 * both share the same styling.
 */
@Component({
  selector: 'dhp-footnote-reference',
  templateUrl: './footnote-reference.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, HtmlToPlaintextPipe],
})
export class FootnoteReferenceComponent {
  readonly footnoteNumber = input.required<number>()
  readonly content = input.required<string>()

  readonly footnoteSelected = output<string>()

  readonly footnoteId = computed(
    () => `footnote-${String(this.footnoteNumber())}`
  )
  readonly referenceId = computed(
    () => `footnote-ref-${String(this.footnoteNumber())}`
  )

  onSelect(event: Event): void {
    event.preventDefault()
    this.footnoteSelected.emit(this.footnoteId())
  }
}
